'use client'

import { Breakpoints } from '@fukku/styles/breakpoints'
import type { PointOfInterestImage } from 'landings/Home/Home.type'
import { pointOfInterestImageLoaderFactory } from 'landings/utils/pointOfInterestImageLoaderFactory'
import { getPointOfInterest } from '../../../utils/getPointOfInterest/getPointOfInterest'
import { BannerImage } from '../../Shared/BannerImage/BannerImage'

type FamilyBannerShopImageProps = {
	readonly image: PointOfInterestImage
	readonly priority?: boolean
}

const ASPECT_RATIO_SMALL_WIDTH = 5
const ASPECT_RATIO_SMALL_HEIGHT = 7
const ASPECT_RATIO_SMALL = ASPECT_RATIO_SMALL_WIDTH / ASPECT_RATIO_SMALL_HEIGHT

const ASPECT_RATIO_MEDIUM_WIDTH = 5
const ASPECT_RATIO_MEDIUM_HEIGHT = 7
const ASPECT_RATIO_MEDIUM =
	ASPECT_RATIO_MEDIUM_WIDTH / ASPECT_RATIO_MEDIUM_HEIGHT

const ASPECT_RATIO_LARGE = 1

const DEFAULT_PIXEL_RATIO = 1
const HALF = 0.5

export function FamilyBannerShopImage({
	image,
	priority = false,
}: FamilyBannerShopImageProps) {
	const pixelRatio = window?.devicePixelRatio ?? DEFAULT_PIXEL_RATIO

	const familyBannerImageLoader = pointOfInterestImageLoaderFactory(
		getPointOfInterest({ image }),
		(width) => {
			if (width < Breakpoints.medium * HALF * pixelRatio) {
				return width / ASPECT_RATIO_SMALL
			}
			if (width < Breakpoints.large * HALF * pixelRatio) {
				return width / ASPECT_RATIO_MEDIUM
			}
			return width / ASPECT_RATIO_LARGE
		}
	)

	return (
		<BannerImage
			image={image}
			sizes={'50vw'}
			imageLoader={familyBannerImageLoader}
			priority={priority}
		/>
	)
}
